import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import SwipeableViews from "react-swipeable-views";
import {
  SlideOutVideo,
  SlideOutActions,
  SlideOutBanner,
  SlideOutSubtitle,
  SlideOutTodoList,
  SlideOutStepper
} from "../../components/SlideOut";
import SlideOutTitle from "../../components/SlideOut/SlideOutTitle";

const useStyles = makeStyles(theme => ({
  adminContainer: theme.mixins.dashedBorder
}));

function StepContainer({ children }) {
  return (
    <Box display="flex" flexDirection="column">
      {children}
    </Box>
  );
}

function Step(props) {
  // TODO: Change to get correct buttons for admin slide out and implement functionality
  function getSlideOutButtons() {
    function handleButtonClick() {
      //TODO: Implement functionality to handle button click
      if (props.activeStep !== props.numSteps - 1) {
        props.setActiveStep(props.activeStep + 1); // Sets the active step to the next step
      }
    }
    return [
      {
        text: "Yes, Add this for my Learners",
        variant: "contained",
        onClick: handleButtonClick
      },
      {
        text: "No, Skip this Step",
        variant: "outlined",
        onClick: handleButtonClick
      }
    ];
  }

  return (
    <React.Fragment>
      {props.subtitle && (
        <Box pb={5.5}>
          <SlideOutSubtitle subtitle={props.subtitle} editable />
        </Box>
      )}
      {props.todoList && <SlideOutTodoList todoList={props.todoList} />}
      {props.videoUrl && <SlideOutVideo link={props.videoUrl} />}
      <SlideOutActions actions={getSlideOutButtons()} />
    </React.Fragment>
  );
}

export default function AdminView(props) {
  const { currentUser } = props;
  const classes = useStyles();
  const theme = useTheme();

  const [activeStep, setActiveStep] = React.useState(0);
  function handleChangeStep(newStepNum) {
    setActiveStep(newStepNum);
  }

  return (
    <React.Fragment>
      {props.banner && <SlideOutBanner {...props.banner} />}
      <Box
        display="flex"
        flexDirection="column"
        pt={2}
        px={2}
        m={2}
        pb={8}
        className={classes.adminContainer}
      >
        <Typography variant="caption" color="textSecondary">
          This is how your learners will see the message. Feel free to edit the
          copy:
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          pt={10}
          px={{ xs: 3, sm: 5 }}
        >
          <SlideOutTitle currentUserFirstName={currentUser.firstName} />
        </Box>
        {props.steps && (
          <Box
            display="flex"
            flexDirection="column"
            pt={10}
            px={{ xs: 3, sm: 5 }}
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={activeStep}
              onChangeIndex={handleChangeStep}
            >
              {props.steps.map((step, index) => (
                <StepContainer key={index} dir={theme.direction}>
                  <Step
                    {...step}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    numSteps={props.steps.length}
                    user={currentUser}
                  />
                </StepContainer>
              ))}
            </SwipeableViews>
            <SlideOutStepper
              activeStep={activeStep}
              numSteps={props.steps.length}
            />
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
}

AdminView.propTypes = {
  banner: PropTypes.object,
  title: PropTypes.string,
  /**
   * An array of steps with content displayed on the welcome slide in the admin screen
   */
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      todoList: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.oneOf(["Assignment", "Announcement", "Policy"]),
          title: PropTypes.string,
          imageSrc: PropTypes.any
        })
      ),
      subtitle: PropTypes.string,
      videoUrl: PropTypes.string
    })
  )
};
